import { useEffect, useState, useReducer } from "react";
import Select from "react-select";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
import { optionSelector } from "../../config/apiSPA.js";

function reducer(state, action) {
  switch (action.type) {
    case "competencyName": {
      return { ...state, competencyName: action.value };
    }
    case "mpName": {
      return { ...state, mpName: action.value };
    }
    case "instructor": {
      return { ...state, instructor: action.value };
    }
    case "activityId": {
      return { ...state, activityId: action.value };
    }
    case "startDate": {
      return { ...state, startDate: action.value, endDate: state.endDate || action.value };
    }
    case "endDate": {
      return { ...state, endDate: action.value };
    }
    case "startTime": {
      return { ...state, startTime: action.value };
    }
    case "endTime": {
      return { ...state, endTime: action.value };
    }
    case "remark": {
      return { ...state, remark: action.value };
    }
  }
}
const initialValue = {
  competencyName: "",
  mpName: "",
  instructor: "",
  activityId: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  remark: "",
};
function MentorReportEvent({ onUpdate = () => {} }) {
  const [eventData, eventDataDispatch] = useReducer(reducer, initialValue);
  const [listCompetencyTitle, setlistCompetencyTitle] = useState([]);
  const [listManpower, setlistManpower] = useState([]);
  const [listInstructor, setlistInstructor] = useState([]);
  const [listMentoringType, setListMentoringType] = useState([]);
  const [modalDuplicateEvent, setModalDuplicateEvent] = useState({ show: false, title: "blank", text: "blank" });
  const [compValue, setCompValue] = useState(null);
  const [spinnerComp, setSpinnerComp] = useState(false);
  const [resultText, setResultText] = useState("");
  function resetForm() {
    eventDataDispatch({ type: "competencyName", value: "" });
    eventDataDispatch({ type: "mpName", value: "" });
    eventDataDispatch({ type: "instructor", value: "" });
    eventDataDispatch({ type: "activityId", value: "" });
    eventDataDispatch({ type: "startDate", value: "" });
    eventDataDispatch({ type: "endDate", value: "" });
    eventDataDispatch({ type: "startTime", value: "" });
    eventDataDispatch({ type: "endTime", value: "" });
    eventDataDispatch({ type: "remark", value: "" });
  }
  function DurationCalc(e) {
    if (e.startDate && e.endDate && e.startTime && e.endTime) {
      const start = new Date(`${e.startDate}T${e.startTime}`);
      const end = new Date(`${e.endDate}T${e.endTime}`);

      if (end >= start) {
        const diffMs = end - start;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
        const diffMinutes = Math.floor((diffMs / (1000 * 60)) % 60);

        if (diffDays >= 1) {
          setResultText(`${diffDays} Day${diffDays > 1 ? "s" : ""}, ` + `${diffHours} Hour${diffHours > 1 ? "s" : ""}, ` + `${diffMinutes} Minute${diffMinutes > 1 ? "s" : ""}`);
        } else {
          setResultText(`${diffHours} Hour${diffHours > 1 ? "s" : ""}, ` + `${diffMinutes} Minute${diffMinutes > 1 ? "s" : ""}`);
        }
      } else {
        setResultText("End date/time must be later than start date/time");
      }
    }
  }
  useEffect(() => {
    DurationCalc(eventData);
    onUpdate(eventData);
  }, [eventData]);
  useEffect(() => {
    setSpinnerComp(true);
    setCompValue(null);
    eventDataDispatch({ type: "competencyName", value: "" });
    if (eventData.activityId && eventData.mpName) {
      optionSelector(`/competency-code-by-mandatory/${eventData.activityId}/${eventData.mpName}`).then((res) => {
        setlistCompetencyTitle(res);
        setSpinnerComp(false);
      });
    }
  }, [eventData.activityId, eventData.mpName]);
  useEffect(() => {
    setSpinnerComp(false);
    resetForm();
    optionSelector(`/competency-code`).then((res) => setlistCompetencyTitle(res));
    optionSelector(`/manpower`).then((res) => setlistManpower(res));
    optionSelector(`/instructor`).then((res) => setlistInstructor(res));
    optionSelector(`/activity-mentoring`).then((res) => setListMentoringType(res));
  }, []);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="activityId">
                    Mentoring Type<span className="text-danger">*</span>
                  </label>
                  <Select id="activityId" options={listMentoringType} onChange={(e) => eventDataDispatch({ type: "activityId", value: e.value })} classNamePrefix="react-select" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="mpName">
                    Mechanic Name<span className="text-danger">*</span>
                  </label>
                  <Select id="mpName" options={listManpower} onChange={(e) => eventDataDispatch({ type: "mpName", value: e.value })} classNamePrefix="react-select" />
                </div>
                <label className="form-label text-theme" htmlFor="title">
                  Competency Name<span className="text-danger">*</span>
                </label>
                {spinnerComp ? (
                  <div className="form-group mb-3">
                    <div className="spinner-border"></div>
                  </div>
                ) : (
                  <div className="form-group mb-3">
                    <Select
                      id="title"
                      value={compValue}
                      options={listCompetencyTitle}
                      onChange={(e) => {
                        eventDataDispatch({ type: "competencyName", value: e.value });
                        setCompValue(e);
                      }}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="instructor">
                    Instructor<span className="text-danger">*</span>
                  </label>
                  <Select id="instructor" options={listInstructor} onChange={(e) => eventDataDispatch({ type: "instructor", value: e.value })} classNamePrefix="react-select" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input type="date" onChange={(e) => eventDataDispatch({ type: "startDate", value: e.target.value })} className="form-control" id="startDate" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input type="date" value={eventData.endDate} onChange={(e) => eventDataDispatch({ type: "endDate", value: e.target.value })} className="form-control" id="endDate" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="startTime">
                    Start Time<span className="text-danger">*</span>
                  </label>
                  <input type="time" onChange={(e) => eventDataDispatch({ type: "startTime", value: e.target.value })} className="form-control" id="startTime" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="endTime">
                    End Time<span className="text-danger">*</span>
                  </label>
                  <input type="time" onChange={(e) => eventDataDispatch({ type: "endTime", value: e.target.value })} className="form-control" id="endTime" />
                </div>
                <div className="d-flex fw-bold small mb-3">
                  <span className="flex-grow-1">{resultText}</span>
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="remark">
                    Remark
                  </label>
                  <textarea onChange={(e) => eventDataDispatch({ type: "remark", value: e.target.value })} className="form-control" id="remark"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalConfirm
        clicked={() => setModalDuplicateEvent({ ...modalDuplicateEvent, show: false })}
        theme={"danger"}
        show={modalDuplicateEvent.show}
        title={modalDuplicateEvent.title}
        text={modalDuplicateEvent.text}
        onHide={() => setModalDuplicateEvent({ ...modalDuplicateEvent, show: false })}
      />
    </>
  );
}

export default MentorReportEvent;
